import React, { useState } from "react";
import AboutPhoto from "../../images/CcxIGLVA.jpeg";
import Photo2 from "../../images/DSC_0263_edit.jpg";
import { FaCheckCircle, FaUsers, FaAward, FaTools } from "react-icons/fa";

function About() {
  const [activeTab, setActiveTab] = useState("mission");
  const stats = [
    { value: "20+", label: "Years of Experience" },
    { value: "2001", label: "Founded in Central Florida" },
    { value: "Full-Service", label: "Site Development Partner" },
  ];

  const tabContent = {
    mission: `Our mission is to deliver high-quality, cost-effective site
      development and construction services. Through honesty,
      transparency, and a commitment to excellence, we aim to build
      long-lasting partnerships and strengthen the communities we
      serve.`,

    service: `We provide end-to-end site development solutions including
      grading, utilities, excavation, concrete, roadway construction,
      and more. We deliver reliable service with attention to detail
      and a strong safety culture.`,

    vision: `Our vision is to become Florida’s most trusted and innovative
      site development contractor — shaping infrastructure that stands
      the test of time, and uplifting the communities that rely on it.`,
  };

  return (
    <>
      <div className="ttm-page-title ttm-bg clearfix">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="ttm-page-title-row-inner">
                <div className="page-title-heading">
                  <h2 className="title">About</h2>
                </div>
                <div className="breadcrumb-wrapper">
                  <span>
                    <a title="Homepage" href="/">
                      <i className="fa fa-house" /> &nbsp; Home
                    </a>
                  </span>
                  <span>About</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ABOUT SECTION */}
      <section className="about-section container">
        <div className="about-grid">
          <div className="about-text">
            <h3 className="subtitle">ABOUT US</h3>
            <h2 className="heading">
              Built On Trust, Driven By <span>Precision</span>
            </h2>
            <p className="lead-copy">
              Established in 2001, BRW is a Central Florida full-service site
              development contracting company capable of handling all of your
              project needs. As a certified Underground Utility and Excavation
              Contractor located in Land O’ Lakes, our mission is to exceed
              expectations through craftsmanship, trust, and innovation.
            </p>

            <div className="stats-row">
              {stats.map((stat) => (
                <div className="stat-card" key={stat.label}>
                  <strong>{stat.value}</strong>
                  <span>{stat.label}</span>
                </div>
              ))}
            </div>

            {/* TAB BUTTONS */}
            <div className="tabs">
              {["mission", "service", "vision"].map((tab) => (
                <button
                  key={tab}
                  className={`tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab.charAt(0).toUpperCase() + tab.slice(1)}
                </button>
              ))}
            </div>

            {/* TAB CONTENT */}
            <div className="tab-content active">
              <span className="tab-kicker">
                {activeTab.charAt(0).toUpperCase() + activeTab.slice(1)}
              </span>
              <p>{tabContent[activeTab]}</p>
            </div>
          </div>

          <div className="about-image">
            <div className="img-frame">
              <img src={AboutPhoto} alt="BRW Team" />
            </div>
          </div>
        </div>
      </section>

      {/* WHY CHOOSE US */}
      <section className="why-section">
        <div className="container why-grid">
          <div className="why-text">
            <h3 className="subtitle">WHY CHOOSE US</h3>
            <h2 className="heading">
              A Smarter, More Disciplined Approach To <span>Every Build</span>
            </h2>
            <p className="lead-copy">
              With decades of experience and a proven record of success, BRW
              delivers unmatched expertise in construction and site development.
              We commit to completing every project on schedule while exceeding
              expectations through innovation, precision, and dedication.
            </p>

            {/* FEATURES GRID */}
            <div className="features-grid">
              <div className="feature">
                <FaCheckCircle className="icon" />
                <h4>Quality Workmanship</h4>
                <p>Precision and excellence on every project we take on.</p>
              </div>
              <div className="feature">
                <FaUsers className="icon" />
                <h4>Trusted Team</h4>
                <p>
                  Experienced professionals committed to your project success.
                </p>
              </div>
              <div className="feature">
                <FaAward className="icon" />
                <h4>Proven Track Record</h4>
                <p>
                  Delivering projects on time, safely, and to the highest
                  standard.
                </p>
              </div>
              <div className="feature">
                <FaTools className="icon" />
                <h4>Advanced Equipment</h4>
                <p>
                  State-of-the-art machinery ensures efficient and safe project
                  completion.
                </p>
              </div>
            </div>
          </div>

          <div className="why-image">
            <img src={Photo2} alt="Why BRW" />
          </div>
        </div>
      </section>

      {/* STYLES */}
      <style jsx>{`
        :root {
          --navy: #0c2d62;
          --accent: #ffa800;
          --light-bg: #edf2f7;
          --ink: #10263c;
          --muted: #627286;
        }

        .about-section {
          position: relative;
          padding: 104px 0 88px;
          background: transparent;
        }
        .about-grid {
          display: grid;
          grid-template-columns: minmax(0, 1.05fr) minmax(320px, 0.95fr);
          gap: 56px;
          align-items: center;
        }
        .about-text {
          max-width: 650px;
        }
        .subtitle {
          color: var(--ink);
          font-weight: 700;
          font-size: 0.88rem;
          letter-spacing: 0.18em;
          text-transform: uppercase;
        }
        .heading {
          margin: 12px 0 18px;
          color: var(--ink);
          font-size: clamp(2.6rem, 4vw, 4.35rem);
          font-weight: 800;
          line-height: 0.98;
          letter-spacing: -0.04em;
        }
        .heading span {
          color: var(--accent);
        }
        .lead-copy {
          margin: 0;
          color: var(--muted);
          font-size: 1.03rem;
          line-height: 1.9;
          max-width: 600px;
        }
        .stats-row {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 14px;
          margin: 30px 0 28px;
        }
        .stat-card {
          padding: 18px 18px 16px;
          border-radius: 22px;
          background: rgba(255, 255, 255, 0.84);
          border: 1px solid rgba(12, 45, 98, 0.08);
          box-shadow: 0 18px 40px rgba(12, 45, 98, 0.07);
          backdrop-filter: blur(8px);
        }
        .stat-card strong {
          display: block;
          color: var(--ink);
          font-size: 1.35rem;
          font-weight: 800;
        }
        .stat-card span {
          display: block;
          margin-top: 8px;
          color: var(--muted);
          font-size: 0.92rem;
          line-height: 1.5;
        }

        .tabs {
          display: inline-flex;
          flex-wrap: wrap;
          gap: 12px;
          margin: 4px 0 18px;
          padding: 10px;
          border-radius: 999px;
          background: rgba(16, 38, 60, 0.06);
        }
        .tab {
          border: 0;
          background: transparent;
          color: var(--ink);
          font-weight: 700;
          padding: 12px 20px;
          border-radius: 999px;
          cursor: pointer;
          transition: background-color 0.25s ease, color 0.25s ease,
            transform 0.25s ease, box-shadow 0.25s ease;
        }
        .tab:hover,
        .tab.active {
          background: var(--ink);
          color: #fff;
          transform: translateY(-1px);
          box-shadow: 0 12px 24px rgba(16, 38, 60, 0.18);
        }
        .tab-content {
          padding: 28px 30px;
          border-radius: 28px;
          background: transparent;
          border: 1px solid rgba(12, 45, 98, 0.08);
          box-shadow: 0 24px 46px rgba(12, 45, 98, 0.08);
          animation: fadeIn 0.4s ease;
        }
        .tab-kicker {
          display: inline-block;
          margin-bottom: 10px;
          color: #9d741d;
          font-size: 0.78rem;
          font-weight: 800;
          letter-spacing: 0.16em;
          text-transform: uppercase;
        }
        .tab-content p {
          margin: 0;
          color: var(--ink);
          line-height: 1.85;
        }

        .about-image {
          display: flex;
          justify-content: center;
        }
        .img-frame {
          position: relative;
          overflow: hidden;
          width: min(100%, 640px);
          padding: 12px;
          border-radius: 24px;
          background: rgba(255, 255, 255, 0.78);
          border: 1px solid rgba(255, 255, 255, 0.85);
          box-shadow: 0 28px 60px rgba(16, 38, 60, 0.16);
          backdrop-filter: blur(10px);
          transition: transform 0.45s ease, box-shadow 0.45s ease;
        }
        .img-frame::before {
          content: "";
          position: absolute;
          inset: 14px -16px -16px 18%;
          border-radius: 22px;
          background: transparent;
          z-index: 0;
        }
        .img-frame img {
          position: relative;
          z-index: 1;
          width: 100%;
          display: block;
          aspect-ratio: 4 / 3;
          object-fit: cover;
          border-radius: 18px;
          transition: transform 0.45s ease, filter 0.45s ease;
        }
        .img-frame:hover {
          transform: translateY(-6px);
          box-shadow: 0 36px 72px rgba(16, 38, 60, 0.2);
        }
        .img-frame:hover img {
          transform: scale(1.03);
          filter: saturate(1.05);
        }
        .why-section {
          position: relative;
          padding: 108px 0 120px;
          background:
            radial-gradient(circle at bottom right, rgba(255, 168, 0, 0.08), transparent 24%),
            linear-gradient(180deg, #eef3f8 0%, #e8eef5 100%);
        }
        .why-grid {
          display: grid;
          grid-template-columns: minmax(0, 1fr) minmax(420px, 1.1fr);
          gap: 48px;
          align-items: center;
        }
        .why-text {
          max-width: 680px;
        }
        .why-image {
          position: relative;
          width: 100%;
        }
        .why-image img {
          width: 100%;
          min-height: 500px;
          object-fit: cover;
          border-radius: 30px;
          box-shadow: 0 30px 64px rgba(16, 38, 60, 0.18);
          transition: transform 0.45s ease, box-shadow 0.45s ease;
        }
        .why-image img:hover {
          transform: translateY(-6px);
          box-shadow: 0 38px 78px rgba(16, 38, 60, 0.22);
        }

        .features-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 18px;
          margin-top: 34px;
        }
        .feature {
          padding: 26px 24px;
          border-radius: 24px;
          background: rgba(255, 255, 255, 0.74);
          border: 1px solid rgba(12, 45, 98, 0.08);
          box-shadow: 0 16px 38px rgba(12, 45, 98, 0.08);
          transition: transform 0.3s ease, box-shadow 0.3s ease,
            border-color 0.3s ease;
        }
        .feature:hover {
          transform: translateY(-4px);
          border-color: rgba(255, 168, 0, 0.34);
          box-shadow: 0 20px 42px rgba(12, 45, 98, 0.12);
        }
        .feature h4 {
          margin: 0 0 8px;
          color: var(--ink);
          font-size: 1.06rem;
          font-weight: 800;
        }
        .feature p {
          margin: 0;
          color: var(--muted);
          line-height: 1.7;
        }
        .feature .icon {
          font-size: 1.4rem;
          color: var(--accent);
          margin-bottom: 14px;
        }

        @keyframes fadeUp {
          from {
            opacity: 0;
            transform: translateY(40px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @media (max-width: 768px) {
          .about-section,
          .why-section {
            padding-top: 84px;
            padding-bottom: 84px;
          }
          .about-grid,
          .why-grid {
            grid-template-columns: 1fr;
            gap: 36px;
          }
          .stats-row,
          .features-grid {
            grid-template-columns: 1fr;
          }
          .tabs {
            display: flex;
            border-radius: 24px;
          }
          .tab {
            width: 100%;
          }
          .tab-content {
            padding: 22px;
          }
          .img-frame img,
          .why-image img {
            min-height: auto;
          }
        }
      `}</style>
    </>
  );
}

export default About;
